import { createAction } from 'redux-actions';

import SwaggerAPI from 'data/SwaggerAPI';

const REQUEST_HEALTH_INTERVALS = 'crops/REQUEST_HEALTH_INTERVALS';
const RECEIVE_HEALTH_INTERVALS = 'crops/RECEIVE_HEALTH_INTERVALS';

const CREATE_SUGGESTION = 'crops/CREATE_SUGGESTION';
const FETCH_SUGGESTIONS = 'crops/FETCH_SUGGESTIONS';
const LIST_SUGGESTIONS = 'crops/LIST_SUGGESTIONS';

const initialState = {
  isFetching: false,
  healthIntervals: [],
  suggestions: [],
  error: undefined,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_HEALTH_INTERVALS: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_HEALTH_INTERVALS: {
      if (!action.payload) return state;
      if (action.error) {
        return {
          ...state,
          isFetching: false,
          error: action.payload,
        };
      }

      return {
        ...state,
        isFetching: false,
        healthIntervals: action.payload,
      };
    }
    case FETCH_SUGGESTIONS: {
      if (!action.payload) return state;
      if (action.error) {
        return {
          ...state,
          isFetching: false,
          error: action.payload,
        };
      }

      const newSuggestions = action.payload;

      return {
        ...state,
        isFetching: false,
        suggestions: newSuggestions.concat(state.suggestions),
      };
    }
    case CREATE_SUGGESTION: {
      if (!action.payload) return state;
      if (action.error) {
        return {
          ...state,
          isFetching: false,
          error: action.payload,
        };
      }

      const newSuggestion = [action.payload];

      return {
        ...state,
        isFetching: false,
        suggestions: newSuggestion.concat(state.suggestions),
      };
    }
    case LIST_SUGGESTIONS: {
      if (!action.payload) return state;
      if (action.error) {
        return {
          ...state,
          isFetching: false,
          error: action.payload,
        };
      }
      return {
        ...state,
        isFetching: false,
        suggestions: action.payload.concat(state.suggestions),
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

const HealthIntervals = (function () {
  const startFetchHealthIntervals = () => ({ type: REQUEST_HEALTH_INTERVALS });
  const fetchHealthIntervals = createAction(RECEIVE_HEALTH_INTERVALS, SwaggerAPI.healthIntervalList);
  const getAllSuggestions = createAction(LIST_SUGGESTIONS, SwaggerAPI.suggestionList);
  const fetchSuggestions = createAction(FETCH_SUGGESTIONS, SwaggerAPI.suggestionList);
  const createSuggestion = createAction(CREATE_SUGGESTION, SwaggerAPI.suggestionCreate);

  const getIsFetchingHealthIntervals = (state) => {
    return state.healthIntervals.isFetching;
  };

  const getErrors = (state) => {
    return state.healthIntervals.error;
  };

  const getHealthIntervals = (state) => {
    return state.healthIntervals.healthIntervals;
  };

  const getSuggestions = (state) => {
    return state.healthIntervals.suggestions;
  };

  return {
    getHealthIntervals,
    getIsFetchingHealthIntervals,
    getErrors,
    fetchHealthIntervals,
    startFetchHealthIntervals,
    getAllSuggestions,
    fetchSuggestions,
    createSuggestion,
    getSuggestions,
  };
})();

export default HealthIntervals;
